module.exports = __webpack_public_path__ + "img/w3_chevron_right_white.7d52371e.png";